import classnames from 'classnames'
import React, { PropsWithChildren, useEffect, useRef } from 'react'
import { IMAGE_FILTER } from '../../utils/detectWebPSupported'
import { FadeInWhenVisible } from '../FadeInWhenVisible'
import pageBannerStyles from './pageBanner.module.scss'

type SidebannerMaskProps = {
    className: string
    src: string
  isBlogListing?: boolean
}

export const SideBannerMask:React.FC<PropsWithChildren<SidebannerMaskProps>> = ({ className, src, isBlogListing=false }) => {
  const allClasses = [className, pageBannerStyles.sideMask]
  const maskBannerClass = [pageBannerStyles.maskParallaxBanner]
  const parallax = useRef<HTMLDivElement>(null)
  const sideBannerMaskRef = useRef<HTMLDivElement>(null)

  if(isBlogListing) allClasses.push(pageBannerStyles['blogListingMask'])

  useEffect(() => {
    function scrollHandler() {
      const element = parallax?.current
      const sideBannerMaskWrap = sideBannerMaskRef?.current

      if (element && sideBannerMaskWrap) {
        const offset = sideBannerMaskWrap.getBoundingClientRect().top

        element.style.transform = `translateZ(${-offset * 0.3}px)`
        element.style.transform = `translatex(${-offset * 0.3}px)`
      }
    }

    window.addEventListener('scroll', scrollHandler)

    return () => window.removeEventListener('scroll', scrollHandler)
  }, [])

  return (
    <div ref={sideBannerMaskRef}>
      <FadeInWhenVisible
        animation="easyFadeInStill"
        transition={{ delay: 0.3, duration: 0.5 }}
      >
        <div className={classnames(allClasses)}>
          <div ref={parallax} className={classnames(maskBannerClass)} style={{ backgroundImage: `url("${src}${IMAGE_FILTER}")` }}>
          </div>
        </div>
      </FadeInWhenVisible>
    </div>
  )
}
